import {ParticipantInfo, ParticipantInfoProps} from 'components';

type Props = ParticipantInfoProps;

export const DEFAULT_USER_SESSION_PARTICIPANT_FIELDS = {
    icon: true,
    platform: true,
    clientCopyId: true,
    asyncRequests: true,
    audioVideoConnectionStatus: true,
    createClientConnection: true,
    onlineStatus: true,
    offlineStatusText: true,
    clientInfoModal: true,
};

export const UserSessionParticipant: React.FC<Props> = (props: Props) => (
    <ParticipantInfo
        fields={DEFAULT_USER_SESSION_PARTICIPANT_FIELDS}
        {...props}
    />
);